import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'What are your minimum order quantities (MOQs)?',
    answer: 'MOQs vary by product category and destination. Hardware wallets typically start at 50-100 units, while accessories like Faraday bags and USB blockers have lower minimums of 25-50 units. Contact us for specific product MOQs.'
  }, {
    question: 'Do you ship internationally?',
    answer: 'Yes, we ship to verified businesses across EU, Middle East, and East Asia. Lead times vary by destination: UAE/GCC (2-5 days), EU (5-10 days), East Asia (7-14 days). Customs clearance and import documentation support included.'
  }, {
    question: 'What payment terms do you offer?',
    answer: 'We offer flexible payment terms for established accounts: Net 30 for verified distributors, 50% deposit + 50% before shipment for new accounts, and Letter of Credit for large orders. Bank transfer and cryptocurrency payments accepted.'
  }, {
    question: 'Are your products authentic and warranty-covered?',
    answer: 'All products are sourced directly from authorized manufacturers with full authenticity guarantees. We provide manufacturer warranties (typically 1-2 years) and handle RMA processes on your behalf.'
  }, {
    question: 'Can I get samples before placing a bulk order?',
    answer: 'Yes, sample orders are available for qualified businesses. Sample pricing is at standard retail rates, which can be credited toward your first bulk order of 100+ units.'
  }, {
    question: 'Do you offer private labeling or custom packaging?',
    answer: 'Custom packaging and private labeling options are available for orders exceeding 500 units. Lead time for custom orders is typically 30-45 days. Contact us to discuss your branding requirements.'
  }, {
    question: 'What documentation do you provide with orders?',
    answer: 'We provide commercial invoices, packing lists, certificates of origin, and product authenticity certificates. For lithium battery products, we include UN38.3 test reports and MSDS documentation for customs clearance.'
  }, {
    question: 'How do I become an authorized reseller?',
    answer: 'Submit a business inquiry through our contact form with your company details, business license, and target market information. We will review your application and respond within 1-2 business days with our line sheet and partnership terms.'
  }];
  return <section id="faq" className="py-20 px-6 relative overflow-hidden bg-white" data-id="element-112">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1600&q=80)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-113" />
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-115">
          <h2 className="text-4xl font-bold text-[#0B1220] mb-4" data-id="element-116">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600" data-id="element-117">
            Everything you need to know about working with us
          </p>
        </motion.div>
        <div className="space-y-4" data-id="element-118">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-md transition-shadow" data-id="element-119">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-120">
                <span className="font-semibold text-[#0B1220] pr-4" data-id="element-121">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-[#3B82F6] flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-122" />
              </button>
              <AnimatePresence data-id="element-123">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-124">
                    <div className="px-6 pb-5 text-gray-700 leading-relaxed" data-id="element-125">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}